import { motion } from "framer-motion";
import { useLang } from "@/lib/lang";

export default function HeroSection() {
  const { t } = useLang();
  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url('https://images.pexels.com/photos/2156883/pexels-photo-2156883.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')` }} />
      <div className="absolute inset-0 bg-[#05050A]/70" />
      <div className="orb w-[500px] h-[500px] bg-[#FF007F]/20 -top-40 -right-40" style={{ animationDelay: "0s" }} />
      <div className="orb w-[400px] h-[400px] bg-[#00F0FF]/15 bottom-20 -left-32" style={{ animationDelay: "2s" }} />
      <div className="orb w-[300px] h-[300px] bg-[#4D00FF]/20 top-1/3 right-1/4" style={{ animationDelay: "4s" }} />
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: "easeOut" }}>
          <p className="label-mono mb-6" data-testid="hero-label">{t("hero_label")}</p>
          <h1 data-testid="hero-title" className="font-['Unbounded'] text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[1.05] mb-6">
            <span className="text-white">Fortis </span>
            <span className="bg-gradient-to-r from-[#00F0FF] via-[#4D00FF] to-[#FF007F] bg-clip-text text-transparent">Digital</span>
            <br /><span className="text-white text-3xl sm:text-4xl lg:text-5xl font-bold">LLC</span>
          </h1>
          <p data-testid="hero-description" className="text-[#A0A0AB] text-base sm:text-lg max-w-2xl mx-auto leading-relaxed mb-10">{t("hero_subtitle")}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="#apps" data-testid="hero-cta-button" className="neon-btn text-base px-8 py-4"
              onClick={(e) => { e.preventDefault(); document.querySelector("#apps")?.scrollIntoView({ behavior: "smooth" }); }}>
              {t("hero_cta")}
            </a>
            <a href="#contact" data-testid="hero-contact-button" className="neon-btn neon-btn-pink text-base px-8 py-4"
              onClick={(e) => { e.preventDefault(); document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" }); }}>
              {t("hero_contact")}
            </a>
          </div>
        </motion.div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#05050A] to-transparent" />
    </section>
  );
}
